module.exports = __webpack_public_path__ + "static/media/se_skrivhastighet_video.c3c62339.mp4";